import { GetCoachProfileWriteList } from '#api/accounts';
import { PROFILE_LIST_INFO } from '../ProfileList/constant';

interface Props {
  compeleteData: GetCoachProfileWriteList | undefined;
}

const ProfileProgressBar = ({ compeleteData }: Props) => {
  const stepLength = PROFILE_LIST_INFO.length;
  const compeleteCount = PROFILE_LIST_INFO.filter(
    info => compeleteData?.[info.type as keyof GetCoachProfileWriteList]
  ).length;

  return (
    <div className="flex flex-col items-center gap-20">
      <div className="w-full bg-gray-200 rounded-8">
        <div
          className={`h-8 rounded-8 `}
          style={{
            width: `${(100 / stepLength) * compeleteCount}%`,
            background: 'linear-gradient(90deg, #7750E9 0%, #B098F9 100%)'
          }}
        ></div>
      </div>
      <div className="flex justify-between w-full">
        <span>{Math.floor((100 / stepLength) * compeleteCount)}% 완성</span>
        <span>{Math.floor(stepLength - compeleteCount)}개 남음</span>
      </div>
    </div>
  );
};

export default ProfileProgressBar;
